import { graphql } from '@/gql';
import { mutationExecute } from '@/Utils/graphqlAPI';

export const chargeForUnpaidRideImmediately = async (requestId: string): Promise<boolean> => {
  const response = await mutationExecute({
    mutation: graphql(`
      mutation ChargeForUnpaidRideImmediately($requestId: String!) {
        chargeForUnpaidRideImmediately(requestId: $requestId) {
          id
        }
      }
    `),
    variables: {
      requestId,
    },
  });

  return !!response.data?.chargeForUnpaidRideImmediately;
};
